import { render, staticRenderFns } from "./chartCardDistribution.vue?vue&type=template&id=3d0f380d&scoped=true"
import script from "./chartCardDistribution.vue?vue&type=script&lang=js"
export * from "./chartCardDistribution.vue?vue&type=script&lang=js"
import style0 from "./chartCardDistribution.vue?vue&type=style&index=0&id=3d0f380d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0f380d",
  null
  
)

export default component.exports